import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppointmentListItemComponent } from '../appointment-list-item';
import { AppointmentModel } from '../../models';

@Component({
  selector: 'hh-appointments-list',
  standalone: true,
  imports: [CommonModule, AppointmentListItemComponent],
  templateUrl: './appointments-list.component.html',
  styleUrls: ['./appointments-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppointmentsListComponent {
  protected readonly appointments: AppointmentModel[] = [
    { type: 'reminder', time: '11:00 AM', label: 'Call Pharmacy' },
    { type: 'appointment', time: '12:30 AM', label: 'Appointment', description: 'Dr. Smith - Cardiology' },
    { type: 'medication', time: '2:00 PM', label: 'Take Medication', description: 'Metformin' },
    { type: 'medication', time: '9:30 PM', label: 'Take Medication', description: 'Trazadone' },
  ];
}
